module.exports = __webpack_public_path__ + "3f16e137/img/boston-lights.a623432f.png";